var angular = require('angular');
/**
 * This ACL is for ACL_TERRITORIES_VIEW
 * it requests a user's territory when a user is not allowed to see all territories
 */
angular.module('pitch.search')
    .factory('ACLInterceptor', ['$q', '$injector', 'config', function($q, $injector , config) {
        var requestInterceptor  = {
            request: function(c) {
                if ('undefined' !== typeof c.url &&
                    c.url.indexOf(config.apiUri + '/search') !== -1 &&
                    'undefined' === typeof c.params.territoryId) {
                    var deferred = $q.defer();
                    Auth = $injector.get('Auth');
                    UserTerritory = $injector.get('UserTerritory');
                    Auth.acl('territories_view')
                        .then(
                            function(isGranted) {
                                if (!isGranted) {
                                    UserTerritory.get({},
                                        function (resp) {
                                            c.params.territoryId = resp.id;
                                            deferred.resolve(c);
                                        },
                                        function () {
                                            deferred.reject(c);
                                        }
                                    );
                                } else {
                                    deferred.resolve(c);
                                }
                            },
                            function() {
                                deferred.reject(c);
                            }
                        );
                    return deferred.promise;
                }
                return c;
            }
        };

        return requestInterceptor ;
    }])

    .config(['$httpProvider', function($httpProvider) {
        $httpProvider.interceptors.push('ACLInterceptor');
    }]);



// WEBPACK FOOTER //
// ./src/SearchClientBundle/Resources/js/angular/services/ACLInterceptor.js